import { Button, notification } from "antd";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";

const ExcelExport = ({ excelData, fileName, title, className, ...rest }) => {
  const fileType =
    "application/und.openxmIformats-officedocument. spreadsheetml. sheet; charset-UTF-8";
  const fileExtension = ".xlsx";
  const exportToExcel = async () => {
    if (!excelData || excelData.length === 0) {
      notification.success({
        message: "No data",
        description: "No record to download.",
      });
      return;
    }
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };
  return (
    <Button
      {...rest}
      onClick={exportToExcel}
      type="submit"
      className={`!bg-primary !border-none !text-white ${className}`}
    >
      {title ?? "Export Users"}
    </Button>
  );
};

export default ExcelExport;
